import {Box, Card, CardContent, Grid, List} from "@deere/fuel-react";
import {Loading} from "../shared/Loading";
import React from "react";

export const RatingPgmCritCategoryCard = ({loading, categoriesList, callbackfn}) => {
    return <Card>
        <CardContent style={{padding: 0}}>
            <Box mt={2}>
                <Grid container alignItems="flex-start" spacing={6}>
                    <Grid item xs={12}>
                        {loading && (
                            <Loading/>
                        )}
                        {!loading && (
                            <List disablePadding component="nav"
                                  aria-label="category list">
                                {categoriesList.map(callbackfn)}
                            </List>
                        )}
                    </Grid>
                </Grid>
            </Box>
        </CardContent>
    </Card>;
}
